import { useEffect } from "react";
import "./app.css";
import "./custom.css";

export default () => {
    const data = [
        {
            id: "e638683e-46e3-4564-afc5-b899a7e67ecf",
            name: "Kai Eatery Commercial Bay",
            address: "7 Queen Street, Auckland Central, Auckland 1010",
            available: true,
        },
        {
            id: "378db4bf-570e-485d-8387-ee6eb58d25aa",
            name: "Kai Eatery Ellerslie",
            address: "604 Great South Road, Ellerslie, Auckland 1051",
            available: true,
        },
    ];

    const onOrder = (link) => {
        window.location.href = `https://order.tabin.co.nz/restaurant/${link}`;
    };

    return (
        <>
            <div className="restaurant-list">
                <img
                    src={`https://d1hfsnuz4i23pd.cloudfront.net/public/2025-04-26_06:16:40.473-2024-10-04_06_59_15.webp`}
                    className="restaurant-list-logo"
                    alt="logo"
                />
                <div className="h4 text-center mb-6">Select a location</div>
                {data &&
                    data.map((restaurant, index) => (
                        <div key={restaurant.id}>
                            {index != 0 && <div className="separator-4"></div>}
                            <div className="restaurant-list-item">
                                <div>
                                    <div className="restaurant-name mb-2">{restaurant.name}</div>
                                    <div>{restaurant.address}</div>
                                </div>
                                <button
                                    className={`button ${restaurant.available ? "" : "disabled"}`}
                                    onClick={() => {
                                        restaurant.available && onOrder(restaurant.id);
                                    }}
                                >
                                    {restaurant.available ? "Order Here" : "Unavailable"}
                                </button>
                            </div>
                        </div>
                    ))}
            </div>
        </>
    );
};
